import { nl } from "../i18n/nl";

export interface ScreenHandle {
  title: string;
}

/** Screens inside the app shell (see docs/design/SCREENS.md). */
export const shellScreens = [
  { path: "/", title: nl.screens.companies },
  { path: "/kaart", title: nl.screens.map },
  { path: "/activiteit", title: nl.screens.activity },
  { path: "/gevolgd", title: nl.screens.followed },
  { path: "/zoeken", title: nl.screens.search },
  { path: "/melden", title: nl.screens.report },
  { path: "/profiel", title: nl.screens.profile },
  { path: "/beheer/moderatie", title: nl.screens.moderation },
  { path: "/beheer/statistieken", title: nl.screens.stats },
  { path: "/beheer/klascodes", title: nl.screens.inviteCodes },
] as const;

/** Full-screen flows without the shell (logged in). */
export const standaloneScreens = [{ path: "/welkom", title: nl.screens.onboarding }] as const;

/** Public: no session needed. */
export const PUBLIC_PATHS = {
  login: "/inloggen",
  register: "/registreren",
  recover: "/herstel",
} as const;

/** Public launch page (no session needed). */
export const LAUNCH_PATH = "/over";

/** Public privacy page in plain language (docs/PRIVACY.md). */
export const PRIVACY_PATH = "/privacy";
